import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {load} from 'flows/docs/signed';

export class RetrieveDealSigned extends React.PureComponent {
  componentDidMount() {
    this.props.load({id: this.props.params.allocationId});
  }
  render() {
    return (
      <div>
        <img src="/images/ring.svg" alt="Loading" />
      </div>
    );
  }
}

RetrieveDealSigned.propTypes = {
  load: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

export default connect(null, {load})(RetrieveDealSigned);



// WEBPACK FOOTER //
// ./web/flows/docs/signed/index.js